/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SensoriseSimDataApiService {
  private history = [];
  public img = '';
  previousUrl;
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  getSensoriseSimDataUsingExcel(Payload): Observable<any> {
    return this.http.post(
      this.APIService + 'sensoriseSimData/getSimDetailsByIccidUsingCsv',
      Payload
    );
  }

  getSensoriseSimDataByIccid(Payload): Observable<any> {
    return this.http.post(
      this.APIService + 'sensoriseSimData/getSimDetailsByIccid',
      Payload
    );
  }
}
